import { Link } from "@StarberryUtils";
import PropTypes from "prop-types";
import React,{useEffect, useState} from "react";
import Slider from 'react-slick';
import {Col, Row, Container } from 'react-bootstrap';
import  "../CaseStudies/CaseStudies.scss";
import studyImg1 from "../../../images/study-image01.jpg"
import studyImg2 from "../../../images/study-image02.jpg"
import studyImg3 from "../../../images/study-image03.jpg";
import studyBanner from "../../../images/study-banner-img.jpg";
import studyBanner376 from "../../../images/study-banner376.jpg";
import studyBanner768 from "../../../images/study-banner768.jpg";
import studyBanner992 from "../../../images/study-banner992.jpg";
import playButton from "../../../images/play-button.svg"
import pattern from "../../../images/pattern.png"
import VideoPlay from "../../Play/VideoPlay";
import ReactMarkdown from "react-markdown"
import { NewsDate } from "../../common/site/functions";
import CustomVideoPlay from "../../Play/custom-video";
import { useStaticQuery, graphql } from "gatsby";

import { LATEST_NEWS_PAGE_URL  } from "../../common/site/constants";

// import { motion } from "framer-motion";
// import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const contentVariants = {
  hidden: {
      opacity: 0
  },
  visible: {
      opacity: 1,
      transition: {
          staggerChildren: 0.4
      }
  }
}

const contentItem = {
  hidden: { opacity: 0, y: -40 },
  visible: (custom) => ({
      opacity: 1,
      y: 0,
      transition: {
          delay: custom * 0.2,
          duration: 0.6,
          ease: [0.33, 1, 0.68, 1],
      },
  })
}

const CaseStudies=(props)=>{


  const data = useStaticQuery(graphql`
    query {
      allStrapiNewsCategories(filter: {Publish: {eq: true}}) {
        edges {
          node {
            URL
            Name
            strapiId
            id
          }
        }
      }
    }
  `);

      const [isPlay,setPlay] = useState(false);
      const [isPlaying,setPlaying] = useState(false);

  const settings =  {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    autoplay: true,
    
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  // document.documentElement.style.setProperty('--animate-duration', '2s');

  return (
      <>
          <section
            className="case-studies"
          >
            <Container>
              <Row>
                <Col md={12}>
                  <div variants={titleVariants}>
                    <h2 className="sec-title text-center text-md-left">{props.title}</h2>
                    <div className="study-head d-md-flex justify-content-between align-items-center">

                      <ReactMarkdown source={props.content} allowDangerousHtml className="editor" />
                      <Link className="btn btn-success d-none d-md-inline-block btn-bg-transparent" to={LATEST_NEWS_PAGE_URL.alias}>view more</Link>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="home-slide-news">
                <Col md={12}>
                  <div
                    variants={contentVariants}
                  >
                    <Slider className="study-slider"  {...settings} >
                      {props.news.map((news, i) => {
                      var cat = ''
                      {props.NewsCategory.map(({node}, i) => {
                      if(node.strapiId == news.Category)
                      {
                        cat = node.URL
                      }
                      })}
                      if(news.URL != "config-don-t-delete") {
                        return (
                          <div
                            key={i}
                            custom={i}
                            variants={contentItem}
                          >
                            <div className="started-details ">
                              <div className="case-study-image-link"><Link to={`${LATEST_NEWS_PAGE_URL.alias}/${cat}/${news.URL}`}><figure className="study-img">
                                  <img loading="lazy" src={news.Tile_Image?.childImageSharp?.gatsbyImageData?.images?.fallback?.src} alt={`${news.Title} - Martyn Gerrard`} />
                                </figure></Link>
                                {news.Content.map((data, i) => {
                                  return (
                                  <>
                                  {data.Embed_Video_URL ?
                                  <CustomVideoPlay title={news.Title} url={data.Embed_Video_URL}/> : '' }
                                  </>
                                  )
                                })}
                              </div>
                              <p className="schedule">{NewsDate(news.Date)}</p>
                              <Link to={`${LATEST_NEWS_PAGE_URL.alias}/${cat}/${news.URL}`}><strong className="study-title d-block">{news.Title}</strong></Link>
                            </div>
                          </div>
                        )
                        }
                      })}
                    </Slider>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
      </>
  );
}

export default CaseStudies
